{
  "R": [0, 0, 0],
  "G": [72, 72, 255],
  "B": [0, 255, 255],
  "A": [0, 64, 128],
  "I": [0, 88, 255]
}
